document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById("pp-color-pill-style")) {
    const style = document.createElement("style");
    style.id = "pp-color-pill-style";
    style.textContent = `
      .pp-product-page .pp-color-pill {
        background: var(--pp-color-pill-bg, #fff) !important;
        color: var(--pp-color-pill-text, var(--pp-navy)) !important;
        border-color: rgba(16,35,63,.24) !important;
        gap: 0 !important;
      }

      .pp-product-page .pp-pill input:checked + .pp-color-pill {
        background: var(--pp-color-pill-bg, #fff) !important;
        color: var(--pp-color-pill-text, var(--pp-navy)) !important;
        border-color: var(--pp-navy) !important;
        box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--pp-navy);
      }
    `;
    document.head.appendChild(style);
  }

  document.querySelectorAll(".pp-product-page").forEach((section) => {
    const productJson = section.querySelector("[data-product-json]");
    const product = productJson ? JSON.parse(productJson.textContent) : null;

    const form = section.querySelector("[data-product-form]");
    const variantInput = section.querySelector("[data-variant-id]");
    const price = section.querySelector("[data-product-price]");
    const compare = section.querySelector("[data-product-compare]");
    const addButton = section.querySelector("[data-add-button]");
    const optionInputs = section.querySelectorAll("[data-option-input]");
    const mobileAtc = section.querySelector("[data-mobile-atc]");
    const mobileAdd = section.querySelector("[data-mobile-add]");
    const mobilePrice = section.querySelector("[data-mobile-price]");

    function money(cents) {
      return Shopify && Shopify.formatMoney
        ? Shopify.formatMoney(cents)
        : `$${(cents / 100).toFixed(2)}`;
    }

    function selectedOptions() {
      const options = [];
      const groups = section.querySelectorAll(".pp-option");
      groups.forEach((group) => {
        const checked = group.querySelector("input:checked");
        options.push(checked ? checked.value : null);
      });
      return options;
    }

    function findVariant() {
      if (!product) return null;
      const opts = selectedOptions();
      return product.variants.find((variant) => {
        return variant.options.every((option, index) => option === opts[index]);
      });
    }

    function updateVariant() {
      const variant = findVariant();
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (mobilePrice) mobilePrice.textContent = money(variant.price);

      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = money(variant.compare_at_price);
          compare.classList.remove("is-hidden");
        } else {
          compare.classList.add("is-hidden");
        }
      }

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? "Add to Cart" : "Sold Out";
      }

      if (mobileAtc) {
        mobileAtc.classList.toggle("is-unavailable", !variant.available);
      }
    }

    optionInputs.forEach((input) => input.addEventListener("change", updateVariant));

    section.querySelectorAll("[data-media-target]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const id = thumb.dataset.mediaTarget;

        section.querySelectorAll(".pp-media-slide").forEach((slide) => {
          slide.classList.toggle("is-active", slide.dataset.mediaId === id);
        });

        section.querySelectorAll(".pp-thumb").forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });

    section.querySelectorAll("[data-size-guide-open]").forEach((btn) => {
      btn.addEventListener("click", () => {
        section.querySelector("[data-size-guide-modal]")?.classList.add("is-open");
      });
    });

    section.querySelectorAll("[data-size-guide-close]").forEach((btn) => {
      btn.addEventListener("click", () => {
        section.querySelector("[data-size-guide-modal]")?.classList.remove("is-open");
      });
    });

    mobileAdd?.addEventListener("click", () => {
      addButton?.click();
    });

    if (mobileAtc && addButton) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          mobileAtc.classList.toggle("is-visible", !entry.isIntersecting);
        },
        { threshold: 0 }
      );

      observer.observe(addButton);
    }
  });
});